import React from "react";
import classNames from 'classnames';
import NumberFormat from 'react-number-format';
import { getFloat } from "../../../../../../utility/format";

export const InputTextComponent = ({ ...props }) => {
    const { className, style } = props;

    const commonStyles = {
        border: "0",
        overflow: "hidden",
        resize: "none",
        height: "auto",
        backgroundColor: 'transparent',
        textAlign: 'left',
        ...style,
    };

    if (props.disabled) {
        return (
            <textarea
                {...props}
                style={commonStyles}
            />
        );
    } else {
        return (
            <input
                className={`form-control text-left ${className}`}
                {...props}
                style={{ backgroundColor: 'transparent' }}
            />
        );
    }
};

export const renderCurrency = ({
    input, meta: { touched, error }, prefix = "Q. ", placeholder, disabled, decimalScale,
}) => {
    const invalid = touched && error;

    let customStyle = {};
    const valueLength = (input.value || "").length;
    if (valueLength <= 5) {
        customStyle = { minWidth: '90px' }
    } else if (valueLength <= 9) {
        customStyle = { minWidth: '121px' }
    } else {
        customStyle = { minWidth: '150px' }
    }

    return (
        <div>
            <NumberFormat
                className={classNames('form-control', { 'is-invalid': invalid })}
                decimalScale={decimalScale ? decimalScale : 2}
                fixedDecimalScale
                placeholder={placeholder}
                value={input.value}
                thousandSeparator
                disabled={disabled}
                prefix={prefix}
                onValueChange={(values) => {
                    input.onChange(values.value);
                }}
                onBlur={() => {
                    input.onBlur(input.value)
                }}
                style={{ ...customStyle }}
            />
            {invalid && (
                <div className="invalid-feedback">
                    {error}
                </div>
            )}
        </div>
    );
};

export const renderCurrencyDisabled = ({
    input, meta: { touched, error }, prefix = "Q. ", placeholder, decimalScale, disabledStyle
}) => {
    const invalid = touched && error;
    const formattedValue = input.value ? `${prefix}${getFloat(input.value).toFixed(decimalScale || 2).replace(/\d(?=(\d{3})+(?!\d))/g, '$&,')}` : '';

    return (
        <div style={{ marginLeft: "5px", marginRight: "5px" }}>
            <span className={classNames('form-control-disabled', { 'is-invalid': invalid })} style={disabledStyle}>
                {formattedValue || placeholder}
            </span>
            {invalid && (
                <div className="invalid-feedback">
                    {error}
                </div>
            )}
        </div>
    );
};

export const renderDollar = ({
    input, decimalScale, placeholder, meta: { touched, error, dirty }, prefix = "$ ",
    numberFormat, onCambio, disabled
}) => {
    const invalid = touched && error;
    let customStyle = {};
    const valueLength = (input.value || "").length;
    if (valueLength <= 5) {
        customStyle = { minWidth: '90px' }
    } else if (valueLength <= 9) {
        customStyle = { minWidth: '121px' }
    } else {
        customStyle = { minWidth: '150px' }
    }

    return (
        <div>
            <NumberFormat
                placeholder={placeholder}
                className={classNames('form-control', { 'is-invalid': invalid })}
                decimalScale={decimalScale || 2}
                format={numberFormat}
                fixedDecimalScale
                disabled={disabled}
                value={input.value}
                thousandSeparator
                prefix={prefix}
                // suffix="$ "
                onValueChange={(values) => {
                    input.onChange(values.value);
                    if (!!onCambio) {
                        onCambio(values.floatValue)
                    }
                }}
                onBlur={() => {
                    input.onBlur(input.value)
                }}
                style={{ ...customStyle, margin: 'auto' }}
            />
            {invalid && (
                <div className="invalid-feedback">
                    {error}
                </div>
            )}
        </div>
    );
};

export const renderDollarDisabled = ({
    input,
    placeholder,
    type,
    meta: { touched, error },
    disabledStyle,
    decimalScale,
}) => {
    const invalid = touched && error;
    const scale = (decimalScale !== undefined && decimalScale !== null) ? decimalScale : 2;

    // Formatear el valor
    const formattedValue = input.value ? `$ ${getFloat(input.value).toFixed(scale).replace(/\d(?=(\d{3})+(?!\d))/g, '$&,')}` : '';

    return (
        <div style={{ marginLeft: "5px", marginRight: "5px" }}>
            <span
                className={classNames("form-control-disabled", { "is-invalid": invalid })}
                style={{
                    border: "0",
                    textAlign: "center",
                    ...disabledStyle,
                }}
            >
                {formattedValue || placeholder}
            </span>
            {invalid && <div className="invalid-feedback">{error}</div>}
        </div>
    );
};

